import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { FirmService } from '../../../Services/firm.service';
import { FirmSelectionService } from '../../../Services/firm-selection.service';
import { NotificationService } from '../../../Services/notification.service';
import { AuthService } from '../../../Services/auth.service';

@Component({
  selector: 'app-customer-header',
  standalone: true,
  imports: [NgIf, NgClass, NgFor, RouterLink, FormsModule],
  templateUrl: './customer-header.component.html',
  styleUrl: './customer-header.component.css'
})
export class CustomerHeaderComponent implements OnInit {

  router = inject(Router);
  authService = inject(AuthService);

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;

  menuOpen = false;
  mobileExpanded: string | null = null;

  /** 🔹 CUSTOMER MENU */
  navbarOptions = [
    {
      lable: 'Home',
      path: '/customer-management/home',
      visible: true
    },
    {
      lable: 'My Orders',
      path: '/customer-management/orders',
      visible: true
    },
    {
      lable: 'Account',
      path: '/customer-management/account',
      visible: true
    }
  ];

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.loadFirms();

    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms();
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
    this.mobileExpanded = null;
  }

  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.firmSelectionService.setselectedFirmName({
          id: firm.id,
          name: firm.name,
          status: firm.gst_status
        });
      }
    });
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((f: any) => f.name);

      let alreadySelectedFirm: any;
      this.firmSelectionService.selectedFirmName$
        .subscribe(firm => {
          alreadySelectedFirm = firm;
          if (firm) this.selectedFirm = firm.name;
        })
        .unsubscribe();

      if (!alreadySelectedFirm && firms.length > 0) {
        const defaultFirm = firms[0];
        this.selectedFirm = defaultFirm.name;
        this.firmSelectionService.setselectedFirmName({
          id: defaultFirm.id,
          name: defaultFirm.name,
          status: defaultFirm.gst_status
        });
      }
    });
  }
  isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    // ✅ Close only if focus moved outside the wrapper
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}
